import styles from './avatar.module.css'
import { cx } from './cx'

/** Инициалы из имени: «Евгений Соколов» → «ЕС», пусто → «?». */
export function initials(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean)
  const letters = parts
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('')
  return letters.length > 0 ? letters : '?'
}

export function Avatar({
  name,
  large = false,
  className,
}: {
  name: string | null
  large?: boolean
  className?: string
}) {
  return (
    <span aria-hidden="true" className={cx(styles.avatar, large && styles.large, className)}>
      {initials(name)}
    </span>
  )
}
